<template>
    <div class="form-elements">
        <div class="row">
            <div class="flex xs12 category">
                <va-card>
                    <form>
                        <div class="row mb-4">
                            <div class="flex md6 sm6 xs12">
                                <h1 class="display-1">{{editing ? $t('catalog.category.editCategory')  :  $t('catalog.category.newCategory')}}</h1>
                            </div>
                            <div class="flex md6 xs12" :style="{textAlign:'right'}">
                                <va-button icon="va-icon fa fa-save" @click.prevent="save"> {{ $t('catalog.category.saveCategory') }}</va-button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="flex md9 sm12">
                                <div class="row">
                                    <div class="flex md6 sm12">
                                        <va-input
                                        v-model="title.value"
                                        :placeholder="$t('catalog.category.title')"
                                        :label="$t('catalog.category.title')"
                                        :error="title.error"
                                        />
                                    </div>
                                    <div class="flex md6 sm12">
                                        <va-input
                                        v-model="slug.value"
                                        :placeholder="$t('catalog.category.slug')"
                                        :label="$t('catalog.category.slug')"
                                        :error="slug.error"
                                        :disabled="editing"
                                        />
                                    </div>
                                    <div class="flex md12">
                                        <p class="display-5 mb-3">{{$t('catalog.category.description')}}</p>
                                        <va-medium-editor @initialized="handleEditorInitialization"></va-medium-editor>
                                    </div>
                                </div>

                            </div>

                            <div class="flex md3 sm12 pa-0">
                                <va-card>
                                    <div class="row">
                                        <div class="flex md12 pt-1">
                                            <selectCategory @update="updateParent" :selected="parentInitSelected" :currentCat="category ? category.uuid : null"></selectCategory>
                                        </div>
                                    </div>
                                </va-card>
                            </div>
                        </div>
                        <div class="row">
                            <div class="flex md12">
                                <p class="display-6 mb-4">{{$t('catalog.category.coverImage')}}</p>
                                <vaFileUpload type="gallery" :multiple="false" dropzone v-model="coverCategory.value" @input="handleChangedImage" file-types=".jpg,.jpeg" @removeFile="handleRemovedImages" :class="{error: coverCategory.error}" />
                            </div>
                        </div>
                        <div class="row">
                            <va-button icon="va-icon fa fa-long-arrow-left" color="gray" :to="{ name: 'categories' }"> {{ $t('catalog.category.backToCategories') }}</va-button>
                            <va-button icon="va-icon fa fa-save" @click.prevent="save"> {{ $t('catalog.category.saveCategory') }}</va-button>
                            <va-button icon="va-icon fa fa-save" outline @click.prevent="saveClose"> {{ $t('catalog.category.saveClose') }}</va-button>
                        </div>
                    </form>
                    <div class="flex-center loader" :class="['flex-center','loader',{loading:loading}]">
                        <spring-spinner
                            :animation-duration="2000"
                            :size="60"
                            :color="$themes.primary"
                        />
                    </div>
                </va-card>
            </div>
        </div>
    </div>
</template>

<script>
import selectCategory from './subComponents/selectCategory.vue'
import slugify from 'slugify'
import { SpringSpinner } from 'epic-spinners'
import vaFileUpload from '../../system/va-file-upload/VaFileUpload.vue'

export default {
    components:{
        SpringSpinner,
        selectCategory,
        vaFileUpload
    },
    data(){
        return {
            editor: null,
            category: null,

            coverCategory: {value : [], error: false},
            uploadedCover: null,
            deletedCover: null,
            updateCover: false,

            title: {value: '', error: false},
            slug: {value: '', error: false},
            categoryDescriptionText: null,
            parent: null,
            parentInitSelected: null,

            loading: false,
        }
    },
    created() {
        this.$store.dispatch('getCategories'); 
        if(this.editing){
            this.loading = true;
            this.getCategory();
        }
    },
    computed:{
        editing(){
            return this.$route.params.uuid != 0;
        },
    },
    watch:{
        title:{
            deep: true,
            handler(t){
                if(!this.editing){
                    this.slug.value = slugify(t.value,{lower: true,strict:true});
                }
            }
        },
        slug:{
            deep: true,
            handler(t){
                if(!this.editing){
                    this.slug.value = slugify(t.value,{lower: true,strict:true});
                }
            }
        },
        category(t,f){
            if(t){
                this.compileExisting();
            }
        },
        categoryDescriptionText(t,f){
            if(this.editor) this.editor.setContent(t);
        },
        uploadedCover(t,f){
            if(t){
                this.parseImage(t);
            }
        }
    },
    methods: {
        getCategory(){
            this.$axios.get('api/categories/getCategory',{
                params : {
                    catuuid: this.$route.params.uuid
                }
            }).then(axRes => {
                this.category = axRes.data;
                this.loading = false;
            }).catch(axErr => {
                this.toastError();
                this.loading = false;
            })
        },
        handleEditorInitialization(editor){
            this.editor = editor;
            if(this.categoryDescriptionText) this.editor.setContent(this.categoryDescriptionText);
        },
        toastError(error){
            var msg = "";
            switch (error) {
                case 'titleRequired':
                    msg = this.$t('catalog.category.titleRequired')
                    break;
                case 'parentCategoryRequired':
                    msg = this.$t('catalog.category.parentCategoryRequired')
                    break;
                case 'slugRequired':
                    msg = this.$t('catalog.category.slugRequired')
                    break;
                case 'coverCategoryRequired':
                    msg = this.$t('catalog.category.coverCategoryRequired')
                    break;
                case 'creationFailed':
                    msg = this.$t('catalog.category.creationFailed')
                    break;
                case 'slugAlreadyTaken':
                    msg = this.$t('catalog.category.slugAlreadyTaken')
                    break;
                default:
                    msg = this.$t('system.genericError')
                    break;
            }
            this.showToast(
                msg,
                {
                    icon:'fa-warning',
                    position: 'bottom-right',
                    duration: 10000,
                    fullWidth: false,
                    className: 'vuestic-toast error'
                },
            )
        },
        save(){
            this.doSave(false);
        },
        saveClose(){
            this.doSave(true);
        },
        
        doSave(close){
            this.loading = true;
            if(this.evalData()){
                if(!this.editing){
                    var payload = this.newCategoryPayload();
                    this.saveNewCategory(payload,close)
                }else{
                    var payload = this.updateCategoryPayload();
                    this.updateCategory(payload,close)
                }
            }else{
                this.loading = false;
            }
        },
        
        newCategoryPayload(){
            var formData = new FormData();
            formData.append('title', this.title.value);
            formData.append('slug', this.slug.value);
            if(this.parent) {
                formData.append('parent', this.parent);
            }
            formData.append('description', this.editor.getContent());
            if(this.coverCategory.value && this.coverCategory.value.length > 0){
                formData.append('file', this.coverCategory.value[0].file);
            }   
            return formData;
        },
        saveNewCategory(payload,close){
            this.$axios.post('api/categories/createNewCategory',payload,{'Content-Type': 'multipart/form-data' })
                .then(axRes => {
                    this.loading = false;
                    this.showToast(
                        this.$t('catalog.category.successCreate'),
                        {
                            icon:'fa-check',
                            position: 'bottom-right',
                            duration: 10000,
                            fullWidth: false,
                            className: 'vuestic-toast'
                        },
                    )
                    if(close){
                        this.$router.push({name:'categories'})
                    }else{
                        this.$router.push('/admin/catalog/category/'+axRes.data)
                        this.loading = true;
                        this.getCategory();
                    }
                }).catch(axErr => {
                    this.loading = false;
                    if(axErr.response.data == 'slugAlreadyTaken'){
                        this.toastError('slugAlreadyTaken');
                        this.slug.error = true;
                        setTimeout(() => {
                            this.slug.error = false;
                        }, 3000);
                    } else {
                        this.toastError('creationFailed');
                    }
                })
        },

        updateCategoryPayload(){
            var formData = new FormData();
            formData.append('uuid', this.category.uuid);
            formData.append('title', this.title.value);
            if(this.parent) {
                formData.append('parent', this.parent);
            }
            formData.append('description', this.editor.getContent());

            if(this.deletedCover){
                formData.append('deletedCover', this.deletedCover)
            }
            if(this.coverCategory.value && this.coverCategory.value.length > 0 && this.updateCover){
                formData.append('file', this.coverCategory.value[0].file);
            }
            return formData;
        },
        updateCategory(payload,close){
            this.$axios.put('api/categories/updateNewCategory',payload,{'Content-Type': 'multipart/form-data' })
                .then(axRes => {
                    this.loading = false;
                    this.showToast(
                        this.$t('catalog.category.successUpdate'),
                        {
                            icon:'fa-check',
                            position: 'bottom-right',
                            duration: 10000,
                            fullWidth: false,
                            className: 'vuestic-toast'
                        },
                    )
                    if(close) return this.$router.push({name:'categories'})
                    this.deletedCover = null;
                    this.getCategory();
                }).catch(axErr => {
                    this.loading = false;
                    this.toastError('updateFailed');
                })
        },
        
        evalData(){
            var err = 0;
            if(this.title.error = (!this.title.value || this.title.value == '')){
                this.toastError('titleRequired');
                err++;
            } 
            if(this.slug.error = (!this.slug.value || this.slug.value == '')){
                this.toastError('slugRequired');
                err++;
            } 
            if(err > 0) return false;
            return true;
        },
        compileExisting(){
            this.title.value = this.category.title;
            this.slug.value = this.category.slug;
            this.uploadedCover = this.category.cover;
            if(this.category.parent){
                this.parentInitSelected = this.category.parent;
            }
            this.categoryDescriptionText = this.category.description;

        },
        updateParent(e){
            this.parent = e;
        },
        parseImage(cover){
            fetch(this.$getAWSAssetUrl(cover.file),{header:new Headers({'Access-Control-Allow-Origin':'*','Content-Type': 'multipart/form-data'})})
            .then(async res => {
                var blob = await res.blob();
                const file = await new File([blob], cover.title, blob);
                this.coverCategory.value = [];
                this.coverCategory.value.push({order: 0, file:file, uuid: cover.uuid});
                this.updateCover = false;
                })
            .catch(err => {
                console.log('err',err)
            })
        },
        handleRemovedImages(){
            this.deletedCover = this.uploadedCover ? this.uploadedCover.uuid : null;
            this.coverCategory.value = [];
        },
        handleChangedImage(){
            this.updateCover = true;
            this.deletedCover = this.uploadedCover ? this.uploadedCover.uuid : null;
        }
    },
}
</script>
